import {
  canonicalUrlIsChalkDev,
  canonicalUrlIsChalkPreprod,
  canonicalUrlIsLocal,
  useCurrentCanonicalUrl,
} from "@/utils/hooks/url/use-current-url";
import { useMemo } from "react";

export function useFaviconPath() {
  const currentUrl = useCurrentCanonicalUrl();

  return useMemo(() => {
    const urlIsStaging =
      canonicalUrlIsChalkDev(currentUrl) || canonicalUrlIsChalkPreprod(currentUrl);
    const urlIsLocal = canonicalUrlIsLocal(currentUrl);

    return urlIsStaging
      ? "/static/chalk-staging.png"
      : urlIsLocal
        ? "/static/chalk-local.png"
        : "/static/chalk.png";
  }, [currentUrl]);
}
